import * as React from 'react';
import Link from 'next/link';
import { cn } from '@/app/lib/utils';

export interface AvatarButtonProps {
  initial: string;
  href?: string;
  className?: string;
}

export const AvatarButton: React.FC<AvatarButtonProps> = ({ initial, href = '/auth/account', className }) => {
  const Comp = href ? Link : 'div';

  return (
    <Comp
      href={href}
      className={cn(
        'bg-coral-300 font-chinook flex size-[34px] items-center justify-center rounded-lg border-0 text-[15px] leading-none font-extrabold text-black lg:size-10 lg:border-2 lg:border-black lg:text-[17px]',
        className
      )}
    >
      <span className="inline-block transform-[translateY(8%)] leading-none">{initial}</span>
    </Comp>
  );
};
